import { PrintWidget } from 'www/modules/print/print-widget'
import PrintWidgetSVG from 'www/svg-icons/print-widget';

export class PromosPrintWidget extends PrintWidget{
    constructor() {
        super();
        this._labelContainer = null;
        this._iconContainer = null;
    }
    init(){
        super.init();
        this.linkEl.insertAdjacentElement("afterbegin",this.iconContainer);
        this.linkEl.insertAdjacentElement("beforeend",this.labelContainer);
        this.onClick.subscribe(e=>{
            this.api.print();
        })
    }
    get labelText() {
        const locale = window.locale || 'en';
        
        let labelText = "";
        
        if (locale === 'de') {
        	labelText = 'Drucken';
        } else if (locale === 'fr') {
        	labelText = "Imprimer";
        } else if (locale === 'es') {
        	labelText = "Imprimir";
        } else if (locale === 'pt') {
        	labelText = "Imprimir";
        } else {
        	labelText = "PRINT";
        }
        
        return `${labelText.toUpperCase()}`;
    }
    get labelContainer() {
        if (this._labelContainer == null) {
            let labelContainer = document.createElement('span');
            labelContainer.classList.add('label-container');
            labelContainer.innerHTML = this.labelText;
            this._labelContainer = labelContainer;
        }
        return this._labelContainer;
    }
    get iconContainer() {
        if (this._iconContainer == null) {
            let iconContainer = document.createElement('span');
            iconContainer.classList.add('icon-container');
            iconContainer.appendChild(PrintWidgetSVG.useSprite);
            this._iconContainer = iconContainer;
        }
        return this._iconContainer;
    }


}
